import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import get from 'lodash/get';
import amplitudeAnalytics from '../../shared/utilities/amplitude';
import { resolveAmplitudePageName } from '../../shared/utilities/amplitudePageMapping';
import endpoints from '../../shared/constants/endpoints';
import { getLocationWithoutCountryPath } from '../../shared/utilities/pathes';
import { store } from '../../redux/store';

/** Custom View Page tracking for mapped routes; profile tabs are tracked in Profile.jsx. */
const AmplitudePageViewTrackingProvider = () => {
  const location = useLocation();
  const countryPathUrl = useSelector((state) => get(state, 'country.selectedCountry.path_url') ?? '');

  // Fire View Page only on URL / country-prefix changes. Do not depend on address or store
  // Redux updates — those caused duplicate "Home" events when users set location before navigating to Menu.
  useEffect(() => {
    let cancelled = false;

    const syncPageView = () => {
      const pathOnly = getLocationWithoutCountryPath(location.pathname, countryPathUrl);
      if (pathOnly === endpoints.profilePage) {
        return;
      }
      const pageName = resolveAmplitudePageName(pathOnly);
      if (!pageName) {
        return;
      }
      if (cancelled) {
        return;
      }
      const state = store.getState();
      amplitudeAnalytics.trackViewPage({
        pageName,
        userSlice: {
          selectedStore: state.user?.selectedStore,
          userAddress: state.user?.userAddress,
          userToken: state.user?.userToken,
        },
      });
    };

    syncPageView();

    return () => {
      cancelled = true;
    };
  }, [location.pathname, countryPathUrl]);

  return null;
};

export default AmplitudePageViewTrackingProvider;
